import { animate, style, transition, trigger } from '@angular/animations';

const visibleStyles = style({ transform: 'translate3d(0, 0, 0)', opacity: 1 });
const hiddenStyles = style({ transform: 'translate3d(60px, 0, 0)', opacity: 0 });

export const toastAlertAnimation = trigger('toastAlert', [
  transition(':enter', [hiddenStyles, animate('0.4s cubic-bezier(0, 0, 0.34, 1.82)', visibleStyles)]),
  transition(':leave', [visibleStyles, animate('0.4s cubic-bezier(0, 0, 0.34, 1.82)', hiddenStyles)]),
]);
